import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enLocale from './locales/en.json'
import frCaLocale from './locales/fr-ca.json'
import frFrLocale from './locales/fr-fr.json'
import esLocale from './locales/es.json'
import deLocale from './locales/de.json'
import ptLocale from './locales/pt.json'
import jaLocale from './locales/ja.json'
import zhLocale from './locales/zh.json'

export const resources = {
  en: {
    translation: enLocale,
  },
  frCa: {
    translation: frCaLocale,
  },
  frFr: {
    translation: frFrLocale,
  },
  es: {
    translation: esLocale,
  },
  de: {
    translation: deLocale,
  },
  pt: {
    translation: ptLocale,
  },
  ja: {
    translation: jaLocale,
  },
  zh: {
    translation: zhLocale,
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

const languageMap: Record<string, string[]> = {
  en: ['en', 'en-us', 'en-ca'], // English
  frCa: ['fr', 'fr-ca'], // French (Canadian)
  frFr: ['fr-fr'], // French (Standard)
  es: ['es-es'], // Spanish
  de: ['de-de'], // German
  pt: ['pt-br'], // Portuguese (Brazil)
  ja: ['ja-jp'], // Japanese
  zh: ['zh-cn'], // Chinese (Simplified)
}

export const changeLanguage = (lang: string) => {
  const mappedLang = Object.keys(languageMap).find(key => languageMap[key]?.includes(lang)) || 'en' // Default to 'en' if no match is found

  i18n.changeLanguage(mappedLang)
}

export default i18n
